import { render } from "./PageDisponibilizarAgenda.vue?vue&type=template&id=4561132e"
import script from "./PageDisponibilizarAgenda.vue?vue&type=script&lang=js"
export * from "./PageDisponibilizarAgenda.vue?vue&type=script&lang=js"

import "./PageDisponibilizarAgenda.vue?vue&type=style&index=0&id=4561132e&lang=css"
/* custom blocks */
import block0 from "./PageDisponibilizarAgenda.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__